import { PLATFORM_LIST } from '../config/platforms';
import { IPlatform } from '../interfaces';

export const getFormatedPlatforms = (platforms: IPlatform) => {
    const formatedPlatforms = Object.entries(platforms).map(([key, value]) => {
        const platform = PLATFORM_LIST.find((item) => item.name === key);

        return { ...platform, isSupported: value };
    });

    return formatedPlatforms;
};

export const getFilteringPlatforms = (platforms: IPlatform, isSupported = true) => {
    const formatedPlatforms = getFormatedPlatforms(platforms);
    const filteringPlatforms = formatedPlatforms.filter(
        (platform) => platform.isSupported === isSupported,
    );

    return filteringPlatforms;
};
